import { getVisitorCountry } from "@/lib/geoCountry";

// Shared, session-cached lookup (see src/lib/geoCountry.js).
export const getUserCountry = () => getVisitorCountry();
